/**
 * Store for pending visitor attributes
 * @module
 */

var _ = require('optimizely-client-fn');

var actionTypes = require('../constants/action_types');
var KeyPath = require('../utils/key_path');

module.exports = {
  initialize: function() {
    this.__state = {} as any;

    this.on(actionTypes.SET_VISITOR_ATTRIBUTE_PENDING, this.__setPendingAttribute);
  },

  /**
   * Get the pending value (promise) for the field, if one exists
   * @param {string|KeyPath} fieldKey
   * @returns {Promise|undefined}
   */
  getPendingAttributeValue: function(fieldKey:string|KeyPath): Promise<any>|undefined {
    if (_.isArray(fieldKey)) {
      fieldKey = fieldKey.concat('pending');
    } else {
      fieldKey = [fieldKey as string, 'pending'];
    }

    return KeyPath.getFieldValue(this.__state, fieldKey);
  },

  /**
   *
   * @param {Object} payload
   * @param {(string|KeyPath)} payload.key - name or key path of attribute
   * @param {Promise} payload.pending - Promise that when resolved, will update the visitor store
   * @private
   */
  __setPendingAttribute: function(payload:any) {
    KeyPath.setFieldValue(this.__state, payload.key, {
      pending: payload.pending,
    });
    this.emitChange();
  },
};
